import React, { useMemo } from 'react';
import './GeoReportPage.scss';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import { PROJECTS } from '../../shared/routes/path';
import Title from '../../shared/components/title/Title';
import useIsMobile from '../../shared/hooks/global/UseIsMobile';
import MobilePageHeader from '../../shared/components/common/mobile-menu/MobilePageHeader';
import useAddon from '../../shared/hooks/global/UseAddon';
import { useGetGeoReports } from '../../shared/api/hooks/geo-report/useGetGeoReports';
import { useGenerateGeoReport } from '../../shared/api/hooks/geo-report/useGenerateGeoReport';
import { useGetGeoReportUsage } from '../../shared/api/hooks/geo-report/useGetGeoReportUsage';
import GeoReportForm, { GeoReportUsage } from './components/geo-report-form/GeoReportForm';
import GeoReportList from './components/geo-report-list/GeoReportList';

const GeoReportPage: React.FC = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const hasAddon = useAddon('GEO_REPORT');

  const { data: reports, isLoading: reportsLoading } = useGetGeoReports();
  const { data: usage } = useGetGeoReportUsage();
  const generateReport = useGenerateGeoReport();

  const isGenerating = useMemo(
    () =>
      (reports ?? []).some(
        (r) => r.status === 'PENDING' || r.status === 'GENERATING'
      ),
    [reports]
  );

  const safeUsage = useMemo(
    () => ({ used: usage?.used ?? 0, limit: usage?.limit ?? 5 }),
    [usage]
  );

  const handleGenerate = (url: string) => {
    generateReport.mutate(url);
  };

  if (!hasAddon) {
    return <Navigate to={PROJECTS} replace />;
  }

  return (
    <div className="page-content page-content--geo-audit">
      <div className="page-box">
        {/* Telefon: tytuł i licznik audytów w górnym pasku zamiast nagłówka strony. */}
        <MobilePageHeader
          title={<span>{t('geoReport.title')}</span>}
          actions={<GeoReportUsage usage={safeUsage} />}
        />
        {!isMobile && (
          <div className="page-box__filters" data-observe-sticky>
            <Title
              title={t('geoReport.title')}
              childrenOnMain={
                <div className="title-box__subtitle">{t('geoReport.subtitle')}</div>
              }
            />
          </div>
        )}

        <div className="page-box__stats">
          <GeoReportForm
            isGenerating={isGenerating}
            onGenerate={handleGenerate}
            usage={safeUsage}
          />

          {!reportsLoading && <GeoReportList reports={reports ?? []} />}
        </div>
      </div>
    </div>
  );
};

export { GeoReportPage };
export default GeoReportPage;